import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { AFFILIATE_URL, trackRegisterClick } from '../utils/tracking';
type Variant = 'primary' | 'onDark' | 'outline';
type Size = 'sm' | 'md' | 'lg';
interface CTAButtonProps {
  label: string;
  location: string;
  variant?: Variant;
  size?: Size;
  withIcon?: boolean;
  className?: string;
}
const SIZES: Record<Size, string> = {
  sm: 'px-4 py-2.5 text-[13px]',
  md: 'px-6 py-3.5 text-[14px]',
  lg: 'px-8 py-4 text-[15px] sm:px-9 sm:py-[18px] sm:text-base'
};
const VARIANTS: Record<Variant, string> = {
  primary: 'bg-brand-600 text-white hover:bg-brand-700 shadow-cta hover:shadow-lift',
  onDark: 'border border-white/25 bg-white/10 text-white backdrop-blur-sm hover:border-white/50 hover:bg-white/16',
  outline: 'border border-line bg-white text-ink-900 hover:border-brand-200 hover:text-brand-600'
};
export function CTAButton({
  label,
  location,
  variant = 'primary',
  size = 'md',
  withIcon = true,
  className = ''
}: CTAButtonProps) {
  return <a href={AFFILIATE_URL} target="_blank" rel="noopener noreferrer sponsored" onClick={() => trackRegisterClick(location, label)} className={`group inline-flex items-center justify-center gap-2 rounded-xl font-semibold transition-[transform,background-color,border-color,box-shadow,color] duration-200 ease-expo hover:-translate-y-0.5 active:translate-y-0 ${SIZES[size]} ${VARIANTS[variant]} ${className}`} data-id="element-27" data-mp="19a7vft5jtq57">
      {label}
      {withIcon && <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-expo group-hover:translate-x-1" aria-hidden="true" data-id="element-28" data-mp="1w8atte6c9837" />}
    </a>;
}